import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import CheckBox from "components/checkbox"
import { ADMIN_ROLE } from "constants/auth-types"

import MediaPlayer from "components/common/MediaPlayer"

import { saveProgress } from "store/user/actions"

class Soundcloud extends Component {
  state = {
    mediaProgress: {
      loaded: 0,
      loadedSeconds: 0,
      played: 0,
      playedSeconds: 0,
    },
  }

  componentWillUnmount() {
    this.saveProgress()
  }

  getMediaProgress = (value) => {
    this.setState({ mediaProgress: value })
  }

  saveProgress = () => {
    const { data, saveProgress } = this.props
    const {
      mediaProgress: { playedSeconds },
    } = this.state

    if (data?.seconds < playedSeconds) {
      let saveData = {
        courseware_id: data.id,
        seconds: playedSeconds,
      }

      saveProgress({ data: saveData })
    }
  }

  onEndedMedia = () => {
    console.log("MEDIA ENDED")
  }

  onPauseMedia = () => {
    this.saveProgress()
  }

  render() {
    const {
      data,
      onMarkComplete,
      auth: { role },
    } = this.props

    const lastProgress = !data?.completed ? data?.seconds : 0
    const forwardStreaming = !data?.completed ? data?.forward_streaming : true
    const isAdmin = ADMIN_ROLE.includes(role)

    return (
      <>
        <div className="checkbox-container">
          <CheckBox
            text="Mark as Complete"
            value={data.completed}
            checked={data.completed}
            id={`chk-complete-${data.id}`}
            tooltip="You are required to Mark this as Completed to complete your progress"
            onClick={() => (onMarkComplete ? onMarkComplete() : false)}
          />
          <p>
            You are required to Mark this as Completed to complete your progress
          </p>
        </div>
        <div className="courseware-details">
          <h3 className="courseware-title">{`${data.name}`}</h3>
          {data.description && (
            <p className="courseware-description">{data.description}</p>
          )}
        </div>
        <MediaPlayer
          media={`${data.url}`}
          onGetMediaProgress={this.getMediaProgress}
          onEndedMedia={this.onEndedMedia}
          lastProgress={lastProgress}
          forwardStreaming={forwardStreaming || isAdmin}
          type={data.type}
        />
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  courses: state.coursesReducer,
  auth: state.authReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ saveProgress }, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(Soundcloud)
